import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';
import type { PublicFormConfig } from './types';

export const getPublicFormConfigAPI = async (
  studioId: string,
  formType: string,
  formId?: string,
) => {
  const response = await baseAPI.get<PublicFormConfig>('forms/public-config', {
    params: {
      studioId: studioId || undefined,
      formType: formType || undefined,
      formId: formId || undefined,
    },
  });
  return response.data;
};

export const useGetPublicFormConfig = (
  studioId: string,
  formType: string,
  formId?: string,
) => {
  return useQuery(
    queryOptions({
      queryKey: QUERY_KEYS.FORM_PUBLIC_CONFIG(studioId, formType, formId),
      queryFn: () => getPublicFormConfigAPI(studioId, formType, formId),
      enabled: Boolean(formId) || (Boolean(studioId) && Boolean(formType)),
      retry: 1,
    }),
  );
};
